// Vinho em Aguardando estoque é com a Flávia (Allan à Adnéia, 29/10/2026: "tudo que for vinho é
// com a Flávia"). O card da entrega mostra o aviso e o botão "Acionar Flávia" com o texto pronto
// para o zap dela; quem copia e manda é a pessoa: o ELO não manda nada a ninguém.
// Vinho é o produto cujo nome começa com "Vinho": taça, abridor e adega "de vinho" não são.

import { ACIONAR_COMPRAS_EMAILS } from './botaoCompras';

const ASSINATURA = { 'adneia@weconnect360.com.br': 'Ad', 'gabriela@weconnect360.com.br': 'Gabi', 'caio@weconnect360.com.br': 'Caio' };

const semAcento = (s) => String(s ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase();

export function ehVinho(produto) {
  return /^vinhos?\b/.test(semAcento(produto));
}

// O selo do cabeçalho manda (o BSeller na hora); sem ele ainda, vale o status do tabelão.
export function vinhoEmAes(pedidoErp, statusDoCabecalho) {
  if (!pedidoErp || !ehVinho(pedidoErp.produto)) return false;
  return semAcento(statusDoCabecalho || pedidoErp.status_pedido).includes('aguardando estoque');
}

// O card de compras (Ag. Compras) de um vinho: o mesmo texto pronto do veredito, para a Flávia
// (Adnéia, 29/10/2026, por clique: "Muda hoje"). Todo texto pronto começa com "Oi Anna!".
export function paraFlavia(texto) {
  return String(texto || '').replace(/(^|\n)Oi Anna!/g, '$1Oi Flávia!');
}

// O quadro roxo fica embaixo do card de Compras (Adnéia, 29/10/2026, com print: "ficou confuso.
// Muda ele para aqui embaixo"). Se o card de Compras mostra o botão de acionar (só em Ag. Compras;
// a conta é a de botaoCompras.js), ele já abre o texto para a Flávia: o quadro some, para não ter
// dois "Acionar Flávia". Card sem botão (lista velha, outra pessoa logada): o quadro fica.
export function quadroVinhoAparece(textoVinho, motivoPendencia, comprasMostraBotao) {
  if (!textoVinho) return false;
  return !(motivoPendencia === 'Ag. Compras' && comprasMostraBotao);
}

// Quem vê o botão e o texto para a Flávia: a mesma lista do "Acionar compras" (Adnéia, 30/10/2026,
// por clique: "Sim, o vinho também"). O atendente vê só o aviso de que é com a Flávia e que a
// gestão aciona; antes, o quadro abria o texto pronto para qualquer pessoa.
export function podeAcionarFlavia(email) {
  return ACIONAR_COMPRAS_EMAILS.includes(String(email || '').trim().toLowerCase());
}

export function assinaturaDe(email) {
  return ASSINATURA[String(email || '').trim().toLowerCase()] || '';
}

// '26/10/2026' antes de hoje = já passou. Data fora desse formato: não diz nada.
function jaPassou(dataBr, hoje) {
  const m = /^(\d{2})\/(\d{2})\/(\d{4})/.exec(String(dataBr || '').trim());
  if (!m) return false;
  const dia = new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1]));
  const ref = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());
  return dia < ref;
}

// Só dado do pedido e do produto: nada do cliente vai no texto.
export function textoFlavia({ pedidoErp, desde, estoque, hoje = new Date(), assinatura = '' }) {
  const p = pedidoErp || {};
  const ids = [
    p.departamento && `marca ${p.departamento}`,
    p.codigo_item_vtex && `SKU ${p.codigo_item_vtex}`,
    p.codigo_fornecedor && `cód. fornecedor ${p.codigo_fornecedor}`,
  ].filter(Boolean);
  const dataDesde = String(desde || '').trim().split(' ')[0];
  let t = `Oi Flávia! O vinho ${p.produto || '?'}${ids.length ? ` (${ids.join(', ')})` : ''} está em Aguardando estoque`
    + `${dataDesde ? ` desde ${dataDesde}` : ''} na entrega ${p.numero_pedido || '?'}.`;
  if (p.dt_prometida) {
    t += ` A data prometida ao cliente é ${p.dt_prometida}${jaPassou(p.dt_prometida, hoje) ? ' e já passou' : ''}.`;
  }
  if (estoque && estoque.found) {
    t += ` Estoque físico ${estoque.fisico_total ?? '?'} e XD ${estoque.xd_total ?? '?'}.`;
  }
  t += ' Ele vem? Se sim, quando chega ao galpão?';
  return assinatura ? `${t}\n\n${assinatura}` : t;
}
